export { default } from './LightboxHeader';
